import { render, staticRenderFns } from "./connectType.vue?vue&type=template&id=189ba360&scoped=true&"
import script from "./connectType.vue?vue&type=script&lang=js&"
export * from "./connectType.vue?vue&type=script&lang=js&"
import style0 from "./connectType.vue?vue&type=style&index=0&id=189ba360&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ba360",
  null
  
)

export default component.exports